/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import PageHeader, { GroupThemedLoggedOutPageHeader } from 'components/features/PageHeader';
import { AppHeader } from './ContentPanel';

import './ContentPanelIframe.css';
import { FormattedMessage } from "../../pages/GroupSetup/GroupSetup.presenter";

class ContentPanelIframe extends React.Component {

  constructor(props) {
    super(props);

    this.checkIframeContent = this.checkIframeContent.bind(this);
    this.clearTimer = this.clearTimer.bind(this);

    this.state = {
      iframeContentLoaded: false,
    };
  }

  componentDidMount() {
    this.checkIframeContent();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  clearTimer() {
    if (this.checkIframeContentTimer) {
      clearTimeout(this.checkIframeContentTimer);
      this.checkIframeContentTimer = null;
    }
  }

  checkIframeContent() {
    this.clearTimer();
    const iframeRef = this.iframeRef;

    this.checkIframeContentTimer = setTimeout(() => {
      const iframeDocument = this.iframeRef.contentDocumnet || this.iframeRef.contentWindow.document;
      const isContentLoaded = iframeDocument.readyState === 'complete';

      this.props.setContentLoaded(isContentLoaded);

      if (isContentLoaded) {
        this.clearTimer();
        this.setState({
          iframeContentLoaded: true,
        });
      } else {
        this.checkIframeContent();
      }
    }, 100);
  }

  renderHeader() {
    const { isLoggedIn, titlePhrase, groupName } = this.props;

    if (isLoggedIn) {
      return (
        <div className="cmp-contentpanel-heading">
          <PageHeader titleClassName="theme-group base color font-title-2" titlePhrase={titlePhrase} />
          <div />
        </div>
      );
    }

    return (
      <AppHeader
        HeaderComponent={GroupThemedLoggedOutPageHeader}
        subTitle={groupName || <FormattedMessage id="groupsetup.backpack.name" /> }
        titlePhrase={titlePhrase}
        onClickLogo={this.props.goLogin}
      />
    );
  }

  render() {
    const { titlePhrase, groupName, children, isFixedWidth, externalUrl } = this.props;

    return (
      <div className={classnames("cmp-contentpanel cmp-contentpanel-iframe", { 'fixedwidth': isFixedWidth})}>

        {this.renderHeader()}

        <div className="cmp-contentpanel-iframe-content">
          <iframe
            ref={(i) => { this.iframeRef = i; }}
            src={externalUrl}
          />
        </div>
      </div>
    );
  }
}

export default ContentPanelIframe;
